import combinedHistoryData from '../../data/history/index.js';

const HistoryWidget = {
    data: null,

    init: function () {
    },

    getData: function () {
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const key = `${month}-${day}`;

        let entry = combinedHistoryData[key];

        if (!entry) {
            entry = combinedHistoryData["default"] || { title: "GENEL KÜLTÜR", text: "Bilgini sına.", year: date.getFullYear() };
        }

        if (Array.isArray(entry)) {
            if (entry.length === 0) {
                entry = combinedHistoryData["default"];
            } else {
                const randomIndex = Math.floor(Math.random() * entry.length);
                entry = entry[randomIndex];
            }
        }

        // Shift year by 1 year (e.g. 2026 -> 2027)
        if (entry) {
            entry = {
                ...entry,
                year: (entry.year || date.getFullYear()) + 1
            };
        }

        return entry;
    },

    getHTML: function () {
        const data = this.getData();
        if (!data) return '';

        const date = new Date();
        const dateStr = date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' }).toUpperCase();

        const title = data.title || "GENEL KÜLTÜR";
        const year = data.year || date.getFullYear();
        const text = data.text || "Tarihte bugün neler oldu? Bilgini sına.";

        return `
            <article class="portal-card history-card" aria-labelledby="history-title">
                <div class="portal-card-header">
                    <span class="portal-card-icon">📅</span>
                    <h2 class="portal-card-title">${dateStr} <span class="history-year">(${year})</span></h2>
                </div>
                <div class="history-content">
                    <h3 id="history-title" class="history-event-title">${title}</h3>
                    <p class="history-event-text">${text}</p>
                </div>
                <div class="portal-card-footer" style="padding-top: 10px;">
                    <button id="solve-today-btn" class="solve-btn" onclick="if(window.HistoryWidget){window.HistoryWidget.startDailyQuiz();}">
                        GÜNÜN SORUSUNU ÇÖZ
                    </button>
                </div>
            </article>
        `;
    },

    startDailyQuiz: function () {
        const data = this.getData();
        if (!data) return;

        const questions = data.questions || [data.question];

        const formattedQuestions = questions.map((q, index) => ({
            id: 90000 + index,
            text: q.text,
            options: q.options,
            correct: typeof q.correct === 'number' ? q.correct : 0
        }));

        if (window.game) {
            window.game.startCustomGame(formattedQuestions, 'history_today');
            if (window.Router) { window.Router.showScreen('game-screen'); }
        }
    }
};

console.log("HistoryWidget Loaded with local combinedHistoryData.");
window.HistoryWidget = HistoryWidget;
export { HistoryWidget };
